module.exports = __webpack_public_path__ + "img/cart-fill.f8e96639.svg";